import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { FooterComponent } from './footer/footer.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { NgSelectModule } from '@ng-select/ng-select';

import { JobsBadgeStatusComponent } from './jobs-badge-status/jobs-badge-status.component';
import { HistoryBadgeStatusComponent } from './history-badge-status/history-badge-status.component';

import { AgmCoreModule } from '@agm/core';
import { DeliveryComponent } from './component/delivery/delivery.component';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { PickUpComponent } from './component/pick-up/pick-up.component';
import { LateDeliveryComponent } from './component/late-delivery/late-delivery.component';
import { PickUpsPerBusinessComponent } from './component/pick-ups-per-business/pick-ups-per-business.component';

import { DriverDeliveriesComponent } from './component/driver-deliveries/driver-deliveries.component';
import { SearchableInputComponent } from './component/searchable-input/searchable-input.component';
import { FormsModule } from '@angular/forms';
import { RegionAutoCompleteComponent } from './region-auto-complete/region-auto-complete.component';

@NgModule({
  declarations: [
    NavBarComponent,
    FooterComponent,
    SideNavComponent,
    JobsBadgeStatusComponent,
    HistoryBadgeStatusComponent,
    DeliveryComponent,
    PickUpComponent,
    LateDeliveryComponent,
    PickUpsPerBusinessComponent,
    DriverDeliveriesComponent,
    SearchableInputComponent,
    RegionAutoCompleteComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgSelectModule,
    QRCodeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCt9Lwn6l5eA5BiKC2uoz4I9w-qEAygNrM',
      libraries: ['places', 'drawing', 'geometry'],
    }),
    ConfirmationPopoverModule,
    FormsModule,
  ],
  providers: [],
  exports: [
    CommonModule,
    TranslateModule,
    QRCodeModule,
    NavBarComponent,
    FooterComponent,
    SideNavComponent,
    JobsBadgeStatusComponent,
    DeliveryComponent,
    PickUpComponent,
    LateDeliveryComponent,
    PickUpsPerBusinessComponent,
    DriverDeliveriesComponent,
    SearchableInputComponent,
    HistoryBadgeStatusComponent,
    RegionAutoCompleteComponent,
  ],
})
export class SharedModule {}
